<template>
	<div class="wrapper">
		<PopupError />
		<route-nav-bar v-if="isDev"></route-nav-bar>
		<router-view />
		<div class="statuses">
			<span class="status">
				Connected:
				<span :class="[connected ? 'active' : 'inactive']">
					{{ connected }}</span
				>
			</span>
			<span class="status">
				Joined game:
				<span :class="[joined ? 'active' : 'inactive']">
					{{ joined ? roomCode : false }}</span
				>
			</span>
		</div>
		<ErrorsList />
		<Rejoin v-if="canRejoin" />
	</div>
</template>

<script>
import RouteNavBar from "@/components/dev/RouteNavBar";
import PopupError from "@/components/ui/PopupError";
import ErrorsList from "@/components/ui/ErrorsList";
import Rejoin from "@/components/ui/Rejoin";
import { mapGetters } from "vuex";

export default {
	components: {
		RouteNavBar,
		PopupError,
		ErrorsList,
		Rejoin,
	},
	computed: {
		...mapGetters([
			"isDev",
			"joined",
			"connected",
			"roomCode",
			"localMock",
		]),
		canRejoin() {
			return (
				!this.joined &&
				this.localMock.socketId &&
				this.localMock.roomCode
			);
		},
	},
};
</script>

<style lang="scss">
@import "./assets/scss/main.scss";

.wrapper {
	height: 100vh;
	display: flex;
	flex-direction: column;
}

.view {
	position: relative;
	flex-grow: 1;
}

.flex-parent {
	display: flex;
	align-items: center;
	justify-content: center;
}

.statuses {
	$active: rgb(31, 201, 107);
	font-size: 12px;
	position: absolute;
	bottom: 20px;
	right: 20px;
	.status {
		margin: 0 8px;
	}
	.active {
		color: $active;
	}
	.inactive {
		color: $red;
	}
}

a.router {
	color: $blue-lightest;
	transition: 0.2s;
	&:hover {
		color: lighten($blue-lightest, 20%);
	}
}
</style>
